// Resource names as constants
export const tenantService = 'tenant';
export const transportService = 'transport';
export const trackingService = 'tracking';
export const invoiceService = 'invoicing';
export const logisticPlanService = 'logisticplan';
export const documentService = 'document';
export const Locations = 'locations';
export const BusinessEntities = 'businessentities';
export const Transports = 'transports';
export const Documents = 'documents';
export const Accounts = 'accounts';
export const Shipments = 'shipments';
export const Contacts = 'contacts';
export const Tenants = 'tenants';
export const currencyService = 'currency';
export const quoteService = 'quote';
export const contractService = 'contract';
export const orderService = 'order';
export const exceptionService = 'exception';
export const tenderingService = 'tendering';
export const ediService = 'edi';
// Transport status string values
export const Created = 'Created';
export const BidPosted = 'BidPosted';
export const Rated = 'Rated';
export const Tendered = 'Tendered';
export const TenderAccepted = 'TenderAccepted';
export const PickedUp = 'PickedUp';
export const InTransit = 'InTransit';
export const Delivered = 'Delivered';
export const Cancelled = 'Cancelled';
export const TruckOrderNotUsed = 'TruckOrderNotUsed ';
export const Closed = 'Closed ';
export const Archived = 'Archived ';
export const LTL = 'LTL';
export const Truckload = 'Truckload';
export const Completed = 'completed';
export const Pickups = 'PickUps';
export const Deliveries = 'Deliveries';
export const PickupsLowerCase = 'pickups';
export const DeliveriesLowerCase = 'deliveries';
export const InTransitLowerCase = 'intransit';
export const Total = 'total';
export const NeedUpdates = 'NeedUpdates';
export const Upcoming = 'upcoming';
// Adapter urls
export const portalAdapter = 'application/vnd.tms.portal+json';
export const mobileAdapter = 'application/vnd.tms.mobile+json';
export const carrierPortalHeader = 'tms-application-carrier';
// tenant urls
export const fetchTenantsUrl = '/tenants';
export const carriersUrl = '/carriers';
export const contactByIdUrl = '/contacts/contactbyid';
export const locationsUrl = '/locations';
export const carrierComplianceUrl = `${carriersUrl}/compliances`;
export const carrierBasicInfoUrl = `${carriersUrl}/basicinfo`;
export const accountsUrl = `/${Accounts}`;
export const locationUrl = `/${Locations}`;
export const fetchLocationById = `/${Locations}/`;
export const addCarrierBasicInfoUrl = `${carriersUrl}/basicinfo`;
export const carrierEquipmentUrl = '/carriers/equipments';
export const unitsOfMeasuresUrl = '/unitsofmeasures';
export const businessEntityUrl = `/${BusinessEntities}`;
export const transportationModeUrl = '/transportationmodes';
export const serviceLevelUrl = '/servicecharges';
export const handlingUnitTypesUrl = '/handlingunittypes';
export const shipmentTypesUrl = '/shipmenttypes';
export const equipmentTypeUrl = '/equipmenttypes';
export const referenceTypeUrl = '/referencetypes';
export const fetchDocumentUrl = `/${Documents}/download`;
export const transportFinancialUrl = '/transports/financials';
export const locationBusinessHoursUrl = '/locations/operationschedules';
export const locationGeoFencesUrl = '/locations/geofences';
export const carrierGeoFencesUrl = '/carriers/geofences';
export const contactsUrl = '/contacts';
export const usersUrl = '/users';
export const contactAssociationEntity = '/businessentities/contacts/associate';

// contract urls
export const contractsUrl = '/contracts';
export const createContractUrl = '/createcontract';
export const contractInformationUrl = '/contractinformation';
// currency urls
export const currenciesUrl = '/currencies';
export const tenantCurrencySupportUrl = '/tenantcurrencysupport';
// exceptions urls
export const exceptionsUrl = '/exceptions';
// loads and transport urls
export const transportsUrl = '/transports';
export const loadsUrl = '/loads';
export const transportMyworkitemDetailsApiUrl = `${transportsUrl}/myworkitems/details`;
export const transportMyWorkitemSummaryApiUrl = `${transportsUrl}/myworkitems`;
export const transportReferencesUrl = `${transportsUrl}/references`;
export const transportProofOfDeliveryUrl = `${transportsUrl}/proofofdelivery`;
// contest and quote urls
export const contestsUrl = '/contests';
// v1 PUT routes return 204 No Content; GET stays on contestsUrl.
export const contestsV1Url = '/v1/contests';
// Used only by the decline PUT.
export const rejectContestUrl = `${contestsV1Url}/reject`;
// Paged contests list (TmsPagedList). The route may become /v1/contests: change it here only.
export const contestsPagedUrl = '/v2/contests';
export const quotesUrl = '/quotes';
// order urls
export const fetchOrdersUrl = '/orders';
export const fetchOrderByIdUrl = `${fetchOrdersUrl}/by-number`;
export const fetchShipmentsUrl = '/shipments';
export const orderShipmentPiecesWeightUrl = `${fetchOrdersUrl}/shipments/pieces-weight`;
// tender urls
// Used only by the accept/decline PUTs; v1 returns 204 No Content.
export const acceptTenderUrl = '/v1/accepttender';
export const rejectTenderurl = '/v1/rejecttender';
export const tendersUrl = '/tendertransports';
export const tendersV1Url = '/v1/tendertransports';
export const trackingTransportUrl = '/tracking/transport';
//Document Management
export const documentUploadUrl = `/${Documents}`;
export const documentDownloadUrl = `/${Documents}/download`;

export const ediFileErrorsUrl = '/ediFiles';
// carrier portal ui navigation urls
export const complianceNavigateUrl = '/compliance';
export const createInsuranceFormNavigateUrl = `${complianceNavigateUrl}/createinsurance`;
export const createLicenseFormNavigateUrl = `${complianceNavigateUrl}/createlicense`;
export const editInsuranceFormNavigateUrl = `${complianceNavigateUrl}/editinsurance`;
export const editLicenseFormNavigateUrl = `${complianceNavigateUrl}/editlicense`;
export const loadManagement = '/loadmanagement';
export const allLoads = `${loadManagement}/allloads`;
export const loadBoardNavUrl = `${loadManagement}/loadboard`;
export const loadSummaryNavUrl = `${loadManagement}/loadsummary`;
export const loadSummaryTenderIdDetailsNavUrl = `${loadManagement}/:loadId`;
export const loadBoardDetailsById = `${loadBoardNavUrl}/:id`;
export const transitLoadsMapUrl = `${loadSummaryNavUrl}/intransitloads/map`;

export const myWorkItems = '/myworkitems';
export const exceptionstransportViewUrl =
  '/myworkitems/exceptions/transportview';
export const tenderViewNavUrl = '/tenders/:tenderId';
export const myworkitemsDamagesClaimsUrl = `${myWorkItems}/damagesandclaims`;
export const createMyworkitemsDamagesClaimsUrl = `${myworkitemsDamagesClaimsUrl}/createclaim`;
export const myWorkItemsExceptionsUrl = `${myWorkItems}/exceptions`;
export const tendersGridUrl = `${myWorkItems}/tenders/tendersgrid`;
export const myworkitemsTrackingmapUrl = `${myWorkItems}/trackingmap`;
export const exceptionsTransportidDetailsUrl = `${myWorkItemsExceptionsUrl}/:transportId`;
export const myworkitemsMissingRateDetailsUrl = `${myWorkItems}/missingratesdetails`;
export const myworkitemsMissingRatesUrl = `${myWorkItems}/missingrates`;
export const myworkitemUpdateCheckCallsUrl = `${myWorkItems}/updatecheckcalls`;
export const myworkitemsCheckcallUpdateCheckCallsUrl = `${myWorkItems}/checkcallupdate/checkcalls`;
export const myworkitemsIntegrationFailureUrl = `${myWorkItems}/integrationfailure`;
export const myworkitemsIntegrationFailureDetailsUrl = `${myworkitemsIntegrationFailureUrl}/failedtransaction`;
export const myworkitemsInvoiceDiscrepancyUrl = `${myWorkItems}/invoicediscrepancy`;
export const myworkitemsLoadBoardNavUrl = `${myWorkItems}/loadboard`;
export const myworkitemsloadBoardDetailsById = `${myworkitemsLoadBoardNavUrl}/:id`;
export const myworkitemsUpdateCheckCallNavUrl = `${myWorkItems}/updatecheckcall/:transporttype`;
export const fetchTrackedTransportsByIdUrl = '/tracking/transport';
export const updateProcessStatusUrl = '/tracking/transportLocationUpdates';
export const exceptionsByParentUrl = '/exceptions/by-parent';
export const settingsUrl = '/settings';

// shipment urls
export const fetchShipmentsSearchById = '/orders/shipments/search/';

// invoice urls
export const fetchCostInvoicesUrl = '/invoices/cost';

export const shipmentProofOfDeliveryUrl = `/orders/orderId/shipments/shipmentNumber/proofofdelivery`;
export const getAddressCoordinates = '/geocoding/address/coordinates';
export const getAllAddressCoordinates = '/geocoding/address/coordinates/all';
export const searchAddress = '/geocoding/address';
export const getTimezone = '/geocoding/timezone';
